import React, { useState } from 'react'
import { DeleteOutlined, PlusOutlined, ArrowLeftOutlined } from '@ant-design/icons'
import { Button, Modal, message } from 'antd'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import useParams from '../../hook/useParams'
import { WhiteWrapper, SearchWrapper } from './group.styled'
import MainTable from '../../components/Basic/MainTable'
import PopupConfirm from '../../components/Basic/PopupConfirm'
import dayjs from 'dayjs'
import { fetchTrackList, deleteTrack, modTrack } from '../../apis/group'
import { useLocation, useNavigate } from 'react-router-dom'
import TrackForm from './TrackForm'

function TrackTable (props) {
  const { t: ln_t } = useTranslation()
  const user = useSelector((state) => state.user)
  const { nowGroup, nowBrand } = user || {}
  const params = useParams({ groupId: nowGroup, brandId: nowBrand, includes: 'user' })
  const { handleFetchParams, fetchParams } = params
  const location = useLocation()
  const navigate = useNavigate()
  const groupRecord = location.state?.record

  const [formMode, setFormMode] = useState(false)

  const handleDelete = async record => {
    const { id } = record || {}

    Modal.confirm({
      title: `${ln_t('track.deleteTrack')}`,
      content: `${ln_t('track.deleteTrack')} ${record?.name}?`,
      onOk: async () => {
        const result = await deleteTrack(id)
        if (result?.status === 204) {
          message.success(ln_t('message.success.remove'))
          handleFetchParams('add', {})
        }
      }
    })
  }

  const handleMod = async (record, key) => {
    const { id } = record || {}
    const res = await modTrack(id, key)
    if (res?.status === 200) {
      message.success(ln_t('message.success.modify'))
      handleFetchParams('add', {})
    }
  }

  const apiFunc = () => fetchTrackList({ ...fetchParams, groupId: groupRecord?.id })
  const columns = [
    { title: ln_t('track.name'), dataIndex: 'name' },
    {
      title: ln_t('track.brand'),
      dataIndex: 'brandId',
      render: (e, record) => groupRecord?.name
    },
    {
      title: ln_t('track.creater'),
      dataIndex: 'creator.name',
      render: (e, record) => record?.creator?.name
    },
    { title: ln_t('util.updatedAt'), dataIndex: 'updatedAt', sorter: true, render: (time) => dayjs(time).format('YYYY-MM-DD') },
    {
      title: `${ln_t('track.status')}`,
      dataIndex: 'status',
      render: (e, record) => <PopupConfirm type="status" checked={e} onConfirm={() => handleMod(record, { status: e ? 0 : 1 })} />
    },
    {
      title: ln_t('util.action'),
      dataIndex: 'id',
      render: (id, record) => <Button size="small" icon={<DeleteOutlined />} onClick={() => handleDelete(record)} />
    }
  ]

  return (
    <WhiteWrapper>
      <h3 style={{ marginBottom: '24px' }}>{ln_t('group.brandUserList')}</h3>
          <SearchWrapper style={{ display: 'flex', justifyContent: 'space-between' }}>
          <Button type="default" icon={<ArrowLeftOutlined />} onClick={() => { navigate('/admin/account') }}>
          {ln_t('util.goBack')}
        </Button>
          <Button type="default" icon={<PlusOutlined />} onClick={() => { setFormMode(true) }}>
          {ln_t('util.add')} {ln_t('track.track')}
        </Button>
        </SearchWrapper>
      <MainTable
        columns={columns}
        rowKey="id"
        apiFunc={apiFunc}
        params={params}
      />
      <TrackForm formMode={formMode} groupRecord={groupRecord} setFormMode={setFormMode} handleFetchParams={handleFetchParams}/>
    </WhiteWrapper>
  )
}

export default TrackTable
